import { CalendarFilled, ClockCircleOutlined } from '@ant-design/icons'
import { DatePicker, Input, message, TimePicker, Typography } from 'antd'
import dayjs from 'dayjs'
import React, { useEffect, useState } from 'react'
import Swal from 'sweetalert2'
import {
  createCaseIssue,
  deleteCaseIssue,
  getCaseIssueStatusList,
  updateCaseIssue,
} from '../../../api/aopsCase.api'
import AopsCommonModalLayout from '../modal/AopsCommonModalLayout'
const { Text } = Typography

const CaseIssueModal = ({
  open = false,
  onClose,
  caseWorkId,
  issueDetail = null,
  selectedIssueId = null,
  setSelectedIssueId = () => {},
  setIssueDetail = () => {},
  fetchCaseDetail = () => {},
}) => {
  const [caseProcess, setCaseProcess] = useState([])
  const [isEdit, setIsEdit] = useState(false)
  const [lastStatusId, setLastStatusId] = useState(null)
  const [formData, setFormData] = useState({
    title: '',
    processId: '',
    slaDate: null,
    slaTime: null,
    memo: '',
  })
  useEffect(() => {
    if (caseProcess && caseProcess.length > 0) {
      const lastProcess = caseProcess[caseProcess.length - 1]
      setLastStatusId(lastProcess?.processId || null)
    }
  }, [caseProcess])

  const resetForm = () => {
    setLastStatusId(null)
    setIsEdit(false)
    setSelectedIssueId(null)
    setIssueDetail(null)
    setFormData({
      title: '',
      processId: '',
      slaDate: null,
      slaTime: null,
      memo: '',
    })
    onClose()
  }
  useEffect(() => {
    if (!open) resetForm()
  }, [open])

  const openErrorModal = (error) => {
    Swal.fire({
      customClass: { popup: 'custom-alert' },
      icon: 'error',
      title: '에러 발생',
      text: error,
    })
  }

  useEffect(() => {
    if (caseWorkId) {
      const fetchCaseIssueStatusList = async () => {
        try {
          const res = await getCaseIssueStatusList(caseWorkId)
          // console.log(res, 'res!!!')
          setCaseProcess(res?.processes || [])
          // return res
        } catch (error) {
          console.log(error)
          setCaseProcess([])
          return
          // openErrorModal(error)
        }
      }
      fetchCaseIssueStatusList()
    }
  }, [caseWorkId])

  // issueDetail이 있으면 수정 모드로 설정하고 폼에 값 바인딩
  useEffect(() => {
    if (issueDetail && open) {
      setIsEdit(true)

      // caseStates.processes를 caseProcess로 설정
      if (issueDetail.caseStates?.processes) {
        setCaseProcess(issueDetail.caseStates.processes)
      }

      // issueDetail에서 현재 선택된 processId 찾기
      // currentStep을 사용해서 caseStates.processes에서 해당 step을 가진 프로세스 찾기
      let currentProcessId = ''
      if (issueDetail.currentStep && issueDetail.caseStates?.processes) {
        const currentProcess = issueDetail.caseStates.processes.find(
          (p) => p.step === issueDetail.currentStep,
        )
        currentProcessId = currentProcess?.processId || ''
      }
      // currentStep이 없으면 다른 방법으로 찾기
      if (!currentProcessId) {
        currentProcessId =
          issueDetail.caseWorkProcessId ||
          issueDetail.caseStates?.currentProcessId ||
          issueDetail.caseStates?.processes?.find((p) => p.isCurrent)
            ?.processId ||
          issueDetail.caseStates?.processes?.[0]?.processId ||
          ''
      }

      // slaDateTime 파싱 ("2026-01-21 00:10:00" 형식)
      const slaDateTime = issueDetail.slaDateTime
        ? dayjs(issueDetail.slaDateTime, 'YYYY-MM-DD HH:mm:ss')
        : null

      setFormData({
        title: issueDetail.title || '',
        processId: currentProcessId,
        slaDate: slaDateTime ? slaDateTime.startOf('day') : null,
        slaTime: slaDateTime ? slaDateTime : null,
        memo: issueDetail.memo || '',
      })
    } else if (!issueDetail && open) {
      // 생성 모드일 때 폼 초기화
      setIsEdit(false)
      setFormData({
        title: '',
        processId: '',
        slaDate: null,
        slaTime: null,
        memo: '',
      })
    }
  }, [issueDetail, open])

  const validateForm = () => {
    if (!formData.title) {
      return false
    }
    if (!formData.processId) {
      return false
    }
    if (!formData.slaDate || !formData.slaTime) {
      return false
    }
    return true
  }

  const handleSubmit = async () => {
    if (!validateForm()) {
      message.error('필수 항목을 입력해주세요')
      return
    }
    const dateStr = formData.slaDate
      ? dayjs(formData.slaDate).format('YYYY-MM-DD')
      : ''
    const timeStr = formData.slaTime
      ? dayjs(formData.slaTime).format('HH:mm')
      : ''
    const payload = {
      caseWorkId: caseWorkId,
      title: formData.title,
      slaDateTime: `${dateStr} ${timeStr}:00`, // 형태: YYYY-MM-DD HH:MM:SS
      caseWorkProcessId: formData.processId,
      memo: formData.memo || '',
    }
    try {
      await createCaseIssue(payload)
      message.success('이슈가 생성되었습니다.')
      resetForm()
      fetchCaseDetail()
    } catch (error) {
      console.log(error)
      const errorMessage =
        error?.response?.data?.detail?.[1]?.description ||
        error?.response?.data?.message ||
        '이슈 생성 중 오류가 발생했습니다.'
      openErrorModal(errorMessage)
    }
  }

  const handleFinalCheck = async () => {
    if (!validateForm()) {
      message.error('필수 항목을 입력해주세요')
      return
    }
    if (!selectedIssueId) {
      message.error('이슈 정보를 찾을 수 없습니다.')
      return
    }
    Swal.fire({
      customClass: { popup: 'custom-alert' },
      title: '최종 확인',
      text: '이슈를 완료하시겠습니까?',
      icon: 'question',
      confirmButtonText: '최종 완료',
      cancelButtonText: '취소',
      showCancelButton: true,
      confirmButtonColor: '#117FFA',
    }).then(async (result) => {
      if (result.isConfirmed) {
        handleUpdateIssue()
      }
    })
  }

  const handleUpdateIssue = async () => {
    if (!validateForm()) {
      message.error('필수 항목을 입력해주세요')
      return
    }
    if (!selectedIssueId) {
      message.error('이슈 정보를 찾을 수 없습니다.')
      return
    }
    const dateStr = formData.slaDate
      ? dayjs(formData.slaDate).format('YYYY-MM-DD')
      : ''
    const timeStr = formData.slaTime
      ? dayjs(formData.slaTime).format('HH:mm')
      : ''
    const payload = {
      issueId: selectedIssueId,
      title: formData.title,
      slaDateTime: `${dateStr} ${timeStr}:00`,
      caseWorkProcessId: formData.processId,
      memo: formData.memo || '',
    }
    try {
      await updateCaseIssue(payload)
      message.success('이슈가 수정되었습니다.')
      resetForm()
      fetchCaseDetail()
    } catch (error) {
      console.log(error)
      const errorMessage =
        error?.response?.data?.detail?.[1]?.description ||
        error?.response?.data?.message ||
        '이슈 수정 중 오류가 발생했습니다.'
      openErrorModal(errorMessage)
    }
  }

  const handleDeleteIssue = async () => {
    if (!selectedIssueId) {
      message.error('이슈 정보를 찾을 수 없습니다.')
      return
    }

    const result = await Swal.fire({
      customClass: { popup: 'custom-alert' },
      title: '이슈 삭제',
      text: ' 이슈를 삭제하시겠습니까?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      confirmButtonText: '삭제',
      cancelButtonText: '취소',
    })

    if (result.isConfirmed) {
      try {
        await deleteCaseIssue(selectedIssueId)
        message.success('이슈가 삭제되었습니다.')
        resetForm()
        fetchCaseDetail()
      } catch (error) {
        console.log(error)
        const errorMessage =
          error?.response?.data?.detail?.[1]?.description ||
          error?.response?.data?.message ||
          '이슈 삭제 중 오류가 발생했습니다.'
        openErrorModal(errorMessage)
      }
    }
  }
  // console.log(caseProcess, 'caseProcess')
  return (
    <AopsCommonModalLayout
      open={open}
      onClose={onClose}
      title={isEdit ? '이슈 발생 확인' : '이슈 생성하기'}
    >
      <div className="form-container case-track-board-modal">
        <div className="form-wrapper">
          <div className="form-section ">
            <label className="form-label">
              이슈 명 <span style={{ color: 'red' }}>*</span>
            </label>
            <div style={{ width: '100%' }}>
              <Input
                placeholder="이슈 제목을 입력해주세요."
                value={formData.title}
                onChange={(e) =>
                  setFormData({ ...formData, title: e.target.value })
                }
                className="form-input"
              />
              <div className="example-text-group">
                <Text className="example-text">이슈 업무란?</Text>
                <Text
                  className="example-text"
                  style={{
                    fontSize: '12px',
                    color: '#585F65',
                    fontWeight: '400',
                  }}
                >
                  특정 시점에 새롭게 발생한 문제·요청·변경 사항 등 개별 사건을
                  등록하고 처리하기 위한 업무
                </Text>
              </div>
            </div>
          </div>
          {/* 케이스 업무 */}
          <div className="form-section ">
            <label className="form-label">
              상태 선택 <span style={{ color: 'red' }}>*</span>
            </label>
            <div
              className="case-level-content"
              style={{ marginLeft: '0', marginTop: '0' }}
            >
              <div className="case-level-content-header">
                <p className="title">현재 이슈 상태를 선택해주세요</p>
              </div>
              <div className="case-select-container">
                <p className="description">케이스 추적 상태값</p>
                <div className="case-select-container-item-wrapper">
                  {caseProcess?.map((item) => {
                    const isSelected = formData.processId === item.processId
                    // console.log(formData.processId, item.processId, 'item')
                    return (
                      <div
                        style={{ cursor: 'pointer' }}
                        onClick={() => {
                          setFormData({
                            ...formData,
                            processId: item.processId,
                          })
                        }}
                        key={item.processId + '-select-container-item'}
                        className={`case-select-container-item ${
                          isSelected ? 'selected' : ''
                        }`}
                      >
                        <div
                          className={`number-badge ${isSelected ? 'selected' : ''}`}
                        >
                          {item.step}
                        </div>
                        <span
                          className={`text ${isSelected ? 'selected' : ''}`}
                        >
                          {item.title}
                        </span>
                      </div>
                    )
                  })}
                </div>
              </div>
            </div>
          </div>
          {/* SLA 마감 시간 선택 */}
          <div className="form-section ">
            <label className="form-label">
              SLA <span style={{ color: 'red' }}>*</span>
            </label>
            <div style={{ width: '100%' }}>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  width: '100%',
                }}
              >
                <DatePicker
                  disabledDate={(current) =>
                    current && current < dayjs().startOf('day')
                  }
                  style={{ flex: 1, height: '48px' }}
                  placeholder="날짜를 선택해주세요"
                  suffixIcon={<CalendarFilled />}
                  value={formData.slaDate}
                  onChange={(date) =>
                    setFormData({ ...formData, slaDate: date })
                  }
                  format="YYYY-MM-DD"
                  className="form-input"
                />
                <span style={{ fontSize: '16px', color: '#585F65' }}>~</span>
                <TimePicker
                  style={{ flex: 1, height: '48px' }}
                  placeholder="시간을 선택해주세요"
                  suffixIcon={<ClockCircleOutlined />}
                  value={formData.slaTime}
                  onChange={(time) =>
                    setFormData({ ...formData, slaTime: time })
                  }
                  minuteStep={10}
                  needConfirm={false}
                  format="HH:mm"
                  className="form-input"
                />
              </div>
            </div>
          </div>

          {/* 메모 */}
          <div className="form-section align-items-center">
            <label className="form-label">메모</label>
            <div style={{ width: '100%' }} className="textarea-with-counter">
              <Input.TextArea
                placeholder="이슈에 관련한 메모를 간단하게 적어주세요."
                value={formData.memo}
                onChange={(e) => {
                  if (e.target.value.length > 200) return
                  setFormData({ ...formData, memo: e.target.value })
                }}
                className="form-textarea"
                rows={6}
              />
              <span className="char-counter">
                {formData.memo.length}자/{200}자
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className="popup-footer">
        {!isEdit ? (
          <>
            <button className="btn-cancel" onClick={resetForm}>
              취소
            </button>
            <button className="btn-submit" onClick={handleSubmit}>
              등록
            </button>
          </>
        ) : (
          <>
            <button
              className="btn-cancel"
              onClick={handleDeleteIssue}
              // style={{ width: '60px' }}
            >
              삭제
            </button>
            <button
              className="btn-submit"
              onClick={
                lastStatusId === formData.processId
                  ? handleFinalCheck
                  : handleUpdateIssue
              }
              // style={{ width: '60px' }}
            >
              {lastStatusId === formData.processId ? '최종 확인 완료' : '수정'}
            </button>
          </>
        )}
      </div>
    </AopsCommonModalLayout>
  )
}

export default CaseIssueModal
